export default __webpack_public_path__ + "static/media/right_girls.4d965747.png";